/**
 * Хеш-роутер на 40 рядків. Повноцінна бібліотека тут зайва:
 * у застосунку десяток екранів і жодних вкладених layout-ів.
 */
import { useEffect, useState } from 'react'

export type Route =
  | { name: 'home' }
  | { name: 'session'; mode: 'daily' | 'module'; moduleId?: string }
  | { name: 'modules' }
  | { name: 'module'; id: string }
  | { name: 'dialogue'; moduleId: string; id: string }
  | { name: 'roleplay'; moduleId: string; id: string }
  | { name: 'insight'; moduleId: string; id: string }
  | { name: 'plan' }
  | { name: 'stats' }
  | { name: 'settings' }
  | { name: 'exam' }
  | { name: 'chat'; moduleId?: string }
  | { name: 'pairs'; id?: string }

function parse(hash: string): Route {
  const path = hash.replace(/^#\/?/, '')
  const [head, a, b] = path.split('/')
  switch (head) {
    case '': case 'home': return { name: 'home' }
    case 'session':
      return a === 'module' && b ? { name: 'session', mode: 'module', moduleId: b } : { name: 'session', mode: 'daily' }
    case 'modules': return { name: 'modules' }
    case 'module': return a ? { name: 'module', id: a } : { name: 'modules' }
    case 'dialogue': return a && b ? { name: 'dialogue', moduleId: a, id: b } : { name: 'modules' }
    case 'roleplay': return a && b ? { name: 'roleplay', moduleId: a, id: b } : { name: 'modules' }
    case 'insight': return a && b ? { name: 'insight', moduleId: a, id: b } : { name: 'modules' }
    case 'plan': return { name: 'plan' }
    case 'stats': return { name: 'stats' }
    case 'settings': return { name: 'settings' }
    case 'exam': return { name: 'exam' }
    case 'chat': return { name: 'chat', moduleId: a }
    case 'pairs': return { name: 'pairs', id: a }
    default: return { name: 'home' }
  }
}

export function navigate(to: string) {
  if (location.hash === `#${to}`) return
  location.hash = to
}

export function back() {
  if (history.length > 1) history.back()
  else navigate('/')
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => parse(location.hash))
  useEffect(() => {
    const onChange = () => {
      setRoute(parse(location.hash))
      // Новий екран завжди починається згори.
      window.scrollTo(0, 0)
    }
    addEventListener('hashchange', onChange)
    return () => removeEventListener('hashchange', onChange)
  }, [])
  return route
}
